module.exports = __webpack_public_path__ + "static/media/logo-talana.f6fe54f2.png";